import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const ChevronUp = createSvgIcon(
  () => (
    <path d="M22.9248 0.65918C22.0459 -0.219727 20.5811 -0.219727 19.7021 0.65918L0.65918 19.6045C-0.219727 20.5811 -0.219727 22.0459 0.65918 22.9248L2.90527 25.1709C3.78418 26.0498 5.24902 26.0498 6.22559 25.1709L21.3623 10.1318L36.4014 25.1709C37.3779 26.0498 38.8428 26.0498 39.7217 25.1709L41.9678 22.9248C42.8467 22.0459 42.8467 20.5811 41.9678 19.6045L22.9248 0.65918Z" />
  ),
  '0 0 43 26'
);
